import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider } from '@mui/material';
import { Page, Header } from 'components';
import FileUpload from './components/FileUpload';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const UploadModule = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	return (
		<Page className={classes.root} title="Upload Module">
			<Header module="Modules" view="Upload" />
			<FileUpload />
		</Page>
	);
};

export default UploadModule;
